// import $ from 'jquery';
import { Router } from 'director/build/director';
import Forms from '../Forms';
import vex from 'vex-js';
import '@selectize/selectize';
import noUiSlider from 'nouislider/distribute/nouislider';

class ShowhomeForm {

  constructor() {

    if (! $('div.wrapper').hasClass('showhome')) {
      return;
    }

    const routes = {
      '/showhome/select/': () => { this.viewSelect(); },
      '/showhome/info/:HouseID': (HouseID) => { this.viewInfo(HouseID); }
    };

    const router = Router(routes);

    router.configure({
      html5history : true,
      convert_hash_in_init: false
    });

    this.router = router;
    this.router.init();

    // this.$price = $('#price');
    // this.$bedroom = $('#bedroom');

    // this.$priceValue = $('#price-value');
    // this.$bedroomValue = $('#bedroom-value');

    // this.$priceHidden = $('input[name="prices"]');
    // this.$bedroomHidden = $('input[name="bedrooms"]');

    // noUiSlider.create(this.$bedroom.get(0), {
    //   start: [ 0, 10 ],
    // 	snap: false,
    //   step: 1,
    // 	connect: true,
    //   behaviour: 'tap-drag',
    //   range: {
    // 		'min': [ 1 ],
    // 		'max': [ 5 ]
    // 	},
    // 	pips: { // Show a scale with the slider
    // 		mode: 'steps',
    // 		density: 2
    // 	}
    // });

    const money = function() {
      this.to = function ( input ) {
        if (input >= 1000000) {
           return "$" + (input / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (input >= 1000) {
           return "$" + (input / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
  		};
      this.from = function ( input ) { };
      return false;
    };

    this._money = new money();


    // return 2 is small
    // return 1 is large
    // return 0 is nothing
    //
    // const filter = function( value, type ){
    // 	//return value % 1000 ? 2 : 1;
    // 	if (value == 1000000) {
    //     return 1;
    //   }
    //
    //   if (value == 2400000) {
    //     return 1;
    //   }
    //
    //   if (value == 300000) {
    //     return 1;
    //   }
    // 	return 0;
    // };

    // noUiSlider.create(this.$price.get(0), {
    //   start: [450000, 1000000],
    //   snap: true,
    //   connect: true,
    //   behaviour: 'tap-drag',
    //   range: (function(startFrom, inc) {
    //     var numItems = 14,
    //       count = startFrom,
    //       ranges = {};
    //
    //     for(var i = 0; i <= numItems; i++) {
    //
    //       var label = (i * (100/numItems)) + '%';
    //
    //       if(i === 0) label = 'min';
    //       if(i === numItems) label = 'max';
    //       ranges[label] = [count];
    //
    //       if(count >= 1000000) {
    //         count += (inc * 2);
    //       } else {
    //         count += inc;
    //       }
    //     }
    //     return ranges;
    //   })(300000, 100000),
    //   pips: { // Show a scale with the slider
    //     mode: 'steps',
    //     filter: filter,
    //     density: 3,
    //     format: this._money
    //   }
    // });

    // this.updateSlider();

  }

  updateSlider() {

    // const prices = [
    //    { min: 350000, max: 450000, value: '$350,000 - $450,000' },
    //    { min: 450001, max: 550000, value: '$450,000 - $550,000' },
    //    { min: 550001, max: 650000, value: '$550,000 - $650,000' },
    //    { min: 650001, max: 750000, value: '$650,000 - $750,000' },
    //    { min: 750001, max: 850000, value: '$750,000 - $850,000' },
    //    { min: 850001, max: 950000, value: '$850,000 - $950,000' },
    //    { min: 950001, max: 1000000, value: '$950,000 - $1M' },
    //    { min: 1000001, max: 1100000, value: '$1M - $1.1M' },
    //    { min: 1100001, max: 1200000, value: '$1.1M - $1.2M' },
    //    { min: 1200001, max: 1300000, value: '$1.2M - $1.3M' },
    //    { min: 1300001, max: 1400000, value: '$1.3M - $1.4M' },
    //    { min: 1400001, max: 1500000, value: '$1.4M - $1.5M' },
    //    { min: 1500001, max: 1800000, value: '$1.5M +' }
    // ];
    //
    // const beds = [
    //    { min: 1, max: 1, value: '1 Bedroom' },
    //    { min: 2, max: 2, value: '2 Bedroom' },
    //    { min: 3, max: 3, value: '3 Bedroom' },
    //    { min: 4, max: 4, value: '4 Bedroom' },
    //    { min: 5, max: 5, value: '5 Bedroom' },
    // ];
    //
    // // Update price slider
    // this.$price.get(0).noUiSlider.on('update', ( values, handle ) => {
    //   let from = this._money.to(values[0]);
    //   let to = this._money.to(values[1]);
    // 	this.$priceValue.html( ` from <strong>${from}</strong> to <strong>${to}</strong>` );
    //   this.updateHidden(values, prices, this.$priceHidden);
    // });
    //
    // // Update bedrooms slider
    // this.$bedroom.get(0).noUiSlider.on('update', ( values, handle ) => {
    //   let from = parseInt(values[0]).toFixed();
    //   let to = parseInt(values[1]).toFixed();
    // 	this.$bedroomValue.html( ` from <strong>${from}</strong> to <strong>${to}</strong>` );
    //   this.updateHidden(values, beds, this.$bedroomHidden);
    // });
  }

  // Trying to conform to salesforce multiple input
  // input type="multiple" value="asdf;123;efefe"
  updateHidden(values, priceRanges, $target) {

    // let from = parseInt(values[0]), // Lower handle
    //   to = parseInt(values[1]),   // Upper handle
    //   ceiling = {max: 0},       // Highest value ( to get match on $950,000+ )
    //   output = '';
    //
    // for (var priceRange of priceRanges) {
    //
    //   // fixed lower end range OR one of the price range values fit between the from/to range
    //   if ((from >= priceRange.min && from <= priceRange.max) || (priceRange.min >= from && priceRange.max <= to)) {
    //     output += `${priceRange.value};`;
    //   }
    //   ceiling = (priceRange.max > ceiling.max) ? priceRange : ceiling;
    // }
    //
    // // Bit of a special case where both values are over highest value.
    // // ceiling is a copy of the highest val object
    // if (from >= ceiling.max && to >= ceiling.max) {
    //   output += `${ceiling.value};`;
    // }
    //
    // //console.log(output);
    //
    // $target.val(output);
  }

  addPrivacy($form, $privacy) {
    $form.find('[data-expand]').on('click', event => {
      vex.open({
        content: $privacy,
        overlayClosesOnClick: false,
        showCloseButton: false,
        appendLocation: '#app',
        afterOpen: $content => {
          $content.removeClass('hide');
          $content.find('.vex-close').on('click', event => {
            vex.close($content.data().vex.id);
          });
        }
      });
    });
  }

  showSection(section) {
    $(`section:not([data-step="${section}"])`).hide();
    let $section = $(`section[data-step="${section}"]`);
    $section.show();
    return $section;
  }

  viewSelect() {
    this.showSection('select');
    //console.log('select');
  }

  viewInfo(HouseID) {
    let $form = this.showSection('info').find('form');
    let $privacy = $('#privacy').html();
    let forms = new Forms;

    $form.find('input[name="showhomeID"]').val(HouseID);

    this.addPrivacy($form, $privacy);
    // forms.add($form, this.success, false);

    $form.submit(function( event ) {
        event.preventDefault();

      $form.find('button.send').prop('disabled', true);
      $form.find('button.send').html(`<span></span>Sending`);

      //  Validates ok, send
      $.ajax({
        type : "POST",
        url  : $form.attr('action'),
        data : $form.serializeArray(),
        statusCode: {
          200: () => {
            // Google Tag Manager
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event'  : 'formSubmissionSuccess',
              'formId' : $form.attr('id')
            });

            // Google Analytic Events
            if (typeof ga !== 'undefined') {
              // ga('send', 'event', 'Forms', 'submit', $form.attr('id'));
              gtag('event', 'submit', { 'event_category': 'Forms', 'event_label': $form.attr('id') });
            }

            // $form.parent().find("h4.thank-you-error").hide();
            // $form.parent().find("h4.thank-you").show();

            // scroll only modal to top so user can see message
            $('div.vex').scrollTop(0);

             // this.success($form);

             // DO success
             $form.parent().find("h4.thank-you-error").hide();
             $form.parent().find("h4.thank-you").show();

             const opt = $form.find('input[name="info"]').is(':checked');
             // const price = $form.find('#price').get(0);
             // const bedroom = $form.find('#bedroom').get(0);

             var timeout = 4000;

             // Set dropdown value to empty to keep placeholder
             // and remove selected class from each option which seems to persist ( BUG ?)
             $form.find('select').each((index, obj) => {
               $(obj).get(0).selectize.clear()
               $(obj).get(0).selectize.$dropdown_content.find('.option').removeClass('selected')
               $(obj).get(0).selectize.setValue("", true)
             });

             $form.find('button.send').prop('disabled', false);
             $form.find('button.send').html(`<span></span>Submit`);
             $form.get(0).reset();
             $form.hide();

             if (opt) {
               $form.parent().find("h4.thank-you").html(`Thank you for registering. <br/><span>We have added you to our database and will email you as new properties become available at this location</span>`);
               timeout = 6000;
             } else {
               $form.parent().find("h4.thank-you").html(`Thank you for registering.`);
             }

             window.setTimeout(() => {
               $form.parent().find("h4.thank-you-error").hide();
               $form.parent().find("h4.thank-you").hide();

               // Reset sliders!
               // bedroom.noUiSlider.set([0, 5]);
               // price.noUiSlider.set([400000, 1000000]);

               $form.show();
             }, timeout);
          },
          500: () => {
            $form.parent().find("h4.thank-you-error").show("slow");
          }
        }
      });

      $form.addClass('submitted');
  });
  }

  success( $form ) {

  }
}

export {ShowhomeForm as default};
